import TimeSlotButton
    from "./TimeSlotButton";

import { useCart }
    from "../../context/CartContext";

import { useAuth }
    from "../../context/AuthContext";

import {
    isFutureSlotET
} from "../../utils/timeUtils";

function TimeSlotsPanel({

    selectedCourt,

    selectedDate,

    timeSlots,

    onAdd,

    onRemove,

}) {

    const {

        items,

        getConflictingItem,

    } = useCart();

    const {
        currentUser
    } = useAuth();

    if (!selectedCourt) {
        return null;
    }

    /* ---------------------------------- */
    /* SLOT SELECTED */
    /* ---------------------------------- */

    const isSlotSelected = (slot) => {

        return items.some(

            (item) =>

                item.courtId ===
                selectedCourt.id &&

                item.date ===
                selectedDate &&

                item.startHour ===
                slot.startHour &&

                item.endHour ===
                slot.endHour
        );
    };

    /* ---------------------------------- */
    /* SLOT BOOKED */
    /* ---------------------------------- */

    const isSlotBooked = (slot) => {

        return (

            slot.status ===
            "booked"
        );
    };

    /* ---------------------------------- */
    /* BOOKED BY CURRENT USER */
    /* ---------------------------------- */

    const isBookedByMe = (slot) => {

        return (

            slot.bookedBy ===
            currentUser?.uid
        );
    };

    /* ---------------------------------- */
    /* CLICK */
    /* ---------------------------------- */

    const handleSlotClick = (slot) => {

        const isBooked =
            isSlotBooked(slot);

        /* BOOKED */

        if (isBooked) {
            return;
        }

        const existingCartItem =
            items.find(

                (item) =>

                    item.courtId ===
                    selectedCourt.id &&

                    item.date ===
                    selectedDate &&

                    item.startHour ===
                    slot.startHour &&

                    item.endHour ===
                    slot.endHour
            );

        /* REMOVE */

        if (existingCartItem) {

            onRemove(
                existingCartItem.id
            );

            return;
        }

        /* ADD */

        onAdd(slot);
    };

    return (

        <div style={styles.container}>

            <h2 style={styles.title}>
                Time Slots
            </h2>

            <div style={styles.grid}>

                {timeSlots.map((slot) => {

                    const selected =
                        isSlotSelected(slot);

                    const conflictingItem =
                        getConflictingItem(

                            selectedDate,

                            slot.startHour,

                            slot.endHour
                        );

                    const blockedByOther =

                        !!conflictingItem &&

                        !selected;

                    /* EXPIRED */

                    const isExpired =

                        !isFutureSlotET(

                            selectedDate,

                            slot.endHour
                        );

                    /* BOOKED */

                    const isBooked =
                        isSlotBooked(slot);

                    const bookedByMe =
                        isBookedByMe(slot);

                    /* DISABLED */

                    const disabled =

                        blockedByOther ||

                        isExpired ||

                        isBooked;

                    return (

                        <div

                            key={slot.slotId}

                            style={
                                styles.slotWrapper
                            }
                        >

                            <div

                                style={{
                                    position:
                                        "relative",
                                }}

                                onMouseEnter={() => {

                                    const removeText =

                                        document.getElementById(

                                            `remove-${slot.slotId}`
                                        );

                                    const inCartText =

                                        document.getElementById(

                                            `cart-${slot.slotId}`
                                        );

                                    if (removeText) {

                                        removeText.style.opacity = 1;

                                        removeText.style.transform =
                                            "translateY(0px)";
                                    }

                                    if (inCartText) {

                                        inCartText.style.opacity = 0;

                                        inCartText.style.transform =
                                            "translateY(-4px)";
                                    }
                                }}

                                onMouseLeave={() => {

                                    const removeText =

                                        document.getElementById(

                                            `remove-${slot.slotId}`
                                        );

                                    const inCartText =

                                        document.getElementById(

                                            `cart-${slot.slotId}`
                                        );

                                    if (removeText) {

                                        removeText.style.opacity = 0;

                                        removeText.style.transform =
                                            "translateY(4px)";
                                    }

                                    if (inCartText) {

                                        inCartText.style.opacity = 1;

                                        inCartText.style.transform =
                                            "translateY(0px)";
                                    }
                                }}
                            >

                                <TimeSlotButton

                                    slot={slot}

                                    isSelected={
                                        selected
                                    }

                                    disabled={
                                        disabled
                                    }

                                    isExpired={
                                        isExpired
                                    }

                                    blockedByOther={
                                        blockedByOther
                                    }

                                    isBooked={
                                        isBooked
                                    }

                                    onClick={
                                        handleSlotClick
                                    }
                                />

                            </div>

                            {/* EXPIRED */}

                            {isExpired && (

                                <div
                                    style={
                                        styles.expiredBox
                                    }
                                >
                                    Slot Ended
                                </div>
                            )}

                            {/* BOOKED */}

                            {!selected &&
                                isBooked && (

                                    <div
                                        style={
                                            styles.bookedBox
                                        }
                                    >

                                        <div
                                            style={{

                                                ...styles.bookedText,

                                                color:
                                                    bookedByMe
                                                        ? "#00ff88"
                                                        : "#f87171",
                                            }}
                                        >

                                            {bookedByMe

                                                ? "Booked By You"

                                                : "Already Booked"
                                            }

                                        </div>

                                    </div>
                                )}

                            {/* IN CART */}

                            {selected && (

                                <div
                                    style={
                                        styles.selectedBox
                                    }
                                >

                                    <div

                                        id={`cart-${slot.slotId}`}

                                        style={
                                            styles.inCart
                                        }
                                    >
                                        ✓ In Cart
                                    </div>

                                    <div

                                        id={`remove-${slot.slotId}`}

                                        style={
                                            styles.removeText
                                        }
                                    >
                                        ✕ Remove
                                    </div>

                                </div>
                            )}

                            {/* BLOCKED */}

                            {blockedByOther && (

                                <div
                                    style={
                                        styles.conflictBox
                                    }
                                >

                                    <div
                                        style={
                                            styles.taken
                                        }
                                    >
                                        Taken
                                    </div>

                                    <div
                                        style={
                                            styles.courtName
                                        }
                                    >

                                        {
                                            conflictingItem.courtName
                                        }

                                    </div>

                                </div>
                            )}

                            {/* AVAILABLE */}

                            {!selected &&
                                !blockedByOther &&
                                !isExpired &&
                                !isBooked && (

                                    <div
                                        style={
                                            styles.addBox
                                        }
                                    >
                                        + Add
                                    </div>
                                )}

                        </div>
                    );
                })}

            </div>

        </div>
    );
}

const styles = {

    container: {

        background:
            "rgba(0,40,70,0.7)",

        padding:
            "30px",

        borderRadius:
            "20px",

        border:
            "1px solid rgba(0,255,150,0.2)",
    },

    title: {

        color:
            "#fff",

        marginBottom:
            "20px",

        fontSize:
            "24px",

        fontWeight:
            "700",
    },

    grid: {

        display:
            "grid",

        gridTemplateColumns:
            "repeat(auto-fit,minmax(140px,1fr))",

        gap:
            "15px",
    },

    slotWrapper: {

        display:
            "flex",

        flexDirection:
            "column",

        gap:
            "6px",
    },

    expiredBox: {

        textAlign:
            "center",

        fontSize:
            "11px",

        fontWeight:
            "700",

        color:
            "#ff6b6b",
    },

    bookedBox: {

        textAlign:
            "center",
    },

    bookedText: {

        fontSize:
            "11px",

        fontWeight:
            "700",
    },

    selectedBox: {

        position:
            "relative",

        height:
            "16px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        overflow:
            "hidden",
    },

    inCart: {

        position:
            "absolute",

        fontSize:
            "11px",

        fontWeight:
            "700",

        color:
            "#00d9f5",

        opacity:
            1,

        transform:
            "translateY(0px)",

        transition:
            "all 0.22s ease",

        pointerEvents:
            "none",
    },

    removeText: {

        position:
            "absolute",

        fontSize:
            "11px",

        fontWeight:
            "700",

        color:
            "#ff6b6b",

        opacity:
            0,

        transform:
            "translateY(4px)",

        transition:
            "all 0.22s ease",

        pointerEvents:
            "none",
    },

    addBox: {

        textAlign:
            "center",

        fontSize:
            "11px",

        fontWeight:
            "700",

        color:
            "#00ff88",
    },

    conflictBox: {

        textAlign:
            "center",

        paddingTop:
            "2px",
    },

    taken: {

        fontSize:
            "11px",

        fontWeight:
            "700",

        color:
            "#7c8796",
    },

    courtName: {

        fontSize:
            "10px",

        color:
            "#b6c2cf",

        overflow:
            "hidden",

        textOverflow:
            "ellipsis",

        whiteSpace:
            "nowrap",
    },
};

export default TimeSlotsPanel;